import "../axxess-chat-preview/axxess-chat-preview.scss";

import { EventAggregator, Subscription } from "aurelia-event-aggregator";
import { autoinject, customElement } from "aurelia-framework";
import { Router } from "aurelia-router";

import { IConversationNavOptions } from "../../../interfaces/i-message";
import { AccountEvent } from "../../../services/auth-service";
import { AxxessChatService } from "../../../services/axxess-chat-service";
import { NotificationsHubEvents } from "../../../enums/signalr-notification-events";
import { INotification } from "../../../interfaces/i-signalr-notifications";
import Infrastructure from "../../../common/infrastructure";

@customElement("axxess-chat-preview")
@autoinject
export class AxxessChatPreview {
    private _ea: EventAggregator;
    private pageNumber: number = 1;
    private pageLength: number = 5;
    private _router: Router;
    private _axxessChatService: AxxessChatService;
    private _eaSubscriptions: Subscription[] = [];
    public conversations: IConversationNavOptions[] = [];
    public unreadConversations: number = 0;
    public shakeMessageIcon: boolean = false;
    public titleChangeInterval: NodeJS.Timer;
    public isLoading: boolean = true;
    public axxessChatUrl: string = `${Infrastructure.axxessCentral}/central-messaging/clinicians/conversation`;

    public constructor(ea: EventAggregator, router: Router, axxessChatService: AxxessChatService) {
        this._ea = ea;
        this._router = router;
        this._axxessChatService = axxessChatService;
    }

    public async attached() {
        this.getAxxessChatConversations();
        this._eaSubscriptions.push(
            this._ea.subscribe(AccountEvent.Selected, async () => {
                await this.getAxxessChatConversations();
            })
        );
        this._eaSubscriptions.push(
            this._ea.subscribe(NotificationsHubEvents.LoadNavbarNotifications, (notification: INotification) => {
                this.loadNewMessageNotifications(notification);
            })
        );
    }

    private redirectToAxxessChat() {
        if (this.unreadConversations === 0) {
            window.open(this.axxessChatUrl, "_self");
        }
    }

    private async loadNewMessageNotifications(notification: INotification) {
        const conversationIndex = this.conversations.findIndex(
            (conversation) => conversation.id === notification.conversationId
        );
        const routeConversationId = this._router.currentInstruction.params.id;
        if (routeConversationId !== notification.conversationId) {
            if (conversationIndex > -1) {
                this.conversations[conversationIndex].unread += 1;
                this.conversations[conversationIndex].text = notification.messageBody;
                const [conversation] = this.conversations.splice(conversationIndex, 1);
                this.conversations.unshift(conversation);
            } else if (this.conversations.length < 5) {
                this.conversations.unshift({
                    id: notification.conversationId,
                    title: null,
                    text: notification.messageBody,
                    unread: 1,
                    createdOn: new Date(notification.createdAt),
                    modifiedOn: new Date(),
                    isAxxessConversation: false,
                    users: [
                        {
                            userId: notification.senderId,
                            firstName: "",
                            lastName: notification.senderName,
                            isCurrentParticipant: false
                        }
                    ],
                    senderName: notification.senderName
                });
            }
            this.shakeMessageIcon = true;
            setTimeout(() => (this.shakeMessageIcon = false), 1000);
        }
        this.unreadConversations = this.conversations.length;
    }

    public async getAxxessChatConversations() {
        this.isLoading = true;
        let result = await this._axxessChatService.getAxxessChatConversations({
            page: this.pageNumber,
            pageLength: this.pageLength
        });
        this.isLoading = false;
        let conversations = result.items ? result.items : [];
        this.conversations = conversations.map((conversation) => ({
            ...conversation,
            users: conversation.users.filter((user) => !user.isCurrentParticipant)
        }));
        this.unreadConversations = result.itemCount;
        if (this.unreadConversations > 0) {
            this.shakeMessageIcon = true;
        }
        setTimeout(() => (this.shakeMessageIcon = false), 1000);
    }

    public detached() {
        this._eaSubscriptions?.forEach((sub) => sub.dispose());
    }
}
